var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveicon = function SvgSaveicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.84 12c-.16 0-.32-.08-.4-.16L3.36 7.68a.387.387 0 0 1 0-.56l.56-.56c.08-.16.4-.16.56.08L7.2 9.36V1.2c0-.24.16-.4.4-.4h.8c.24 0 .4.16.4.4v8.16l2.72-2.72c.16-.16.4-.16.56 0l.56.56c.16.16.16.4 0 .56l-4.08 4.08c-.08.08-.24.16-.4.16h-.32Zm7.36-1.2v2.8c0 .88-.72 1.6-1.6 1.6H2.4c-.88 0-1.6-.72-1.6-1.6v-2.8c0-.24.16-.4.4-.4H2c.24 0 .4.16.4.4v2.8h11.2v-2.8c0-.24.16-.4.4-.4h.8c.24 0 .4.16.4.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgSaveicon;